import { uuid } from './regex';

export const ScreeningsRoutes = {
    path: 'screenings',
    details: {
        path: `:screeningId(${uuid})`,
    },
    create: {
        path: 'create',
    },
    sample: {
        path: 'sample',
        docType: {
            path: ':sample(pf|pj)',
        },
    },
    explain: {
        path: 'explain',
        create: {
            path: 'create',
        },
        points: {
            path: 'points',
        },
        prime: {
            path: 'prime',
        },
    },
};
